import { useParams } from "react-router-dom";
export var useArticleId = function useArticleId() {
  var articleId = useParams().articleId;
  return articleId;
};